var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["Xxs"] = 0] = "Xxs";
    Breakpoints[Breakpoints["Xs"] = 400] = "Xs";
    Breakpoints[Breakpoints["Sm"] = 600] = "Sm";
    Breakpoints[Breakpoints["Md"] = 900] = "Md";
    Breakpoints[Breakpoints["Lg"] = 1200] = "Lg";
    Breakpoints[Breakpoints["Xl"] = 1800] = "Xl";
})(Breakpoints || (Breakpoints = {}));
var MediaBreakpoints;
(function (MediaBreakpoints) {
    MediaBreakpoints["Mobile"] = "(min-width: 0px) and (max-width: 599.98px)";
    MediaBreakpoints["Tablet"] = "(min-width: 600px) and (max-width: 899.98px)";
    MediaBreakpoints["Desktop"] = "(min-width: 900px)";
    MediaBreakpoints["MobilePlus"] = "(min-width: 0px)";
    MediaBreakpoints["TabletPlus"] = "(min-width: 600px)";
})(MediaBreakpoints || (MediaBreakpoints = {}));
var ColorTheme;
(function (ColorTheme) {
    ColorTheme["Primary"] = "primary";
    ColorTheme["Secondary"] = "secondary";
})(ColorTheme || (ColorTheme = {}));
var LabelPosition;
(function (LabelPosition) {
    LabelPosition["Top"] = "-top";
    LabelPosition["Left"] = "-left";
    LabelPosition["Bottom"] = "-bottom";
    LabelPosition["Right"] = "-right";
})(LabelPosition || (LabelPosition = {}));
var Position;
(function (Position) {
    Position["Top"] = "top";
    Position["Left"] = "left";
    Position["Right"] = "right";
    Position["Bottom"] = "bottom";
    Position["TopRight"] = "top-right";
    Position["BottomRight"] = "bottom-right";
    Position["TopLeft"] = "top-left";
    Position["BottomLeft"] = "bottom-left";
})(Position || (Position = {}));
var SlideDirection;
(function (SlideDirection) {
    SlideDirection["Right"] = "right";
    SlideDirection["Left"] = "left";
    SlideDirection["Neutral"] = "neutral";
})(SlideDirection || (SlideDirection = {}));
var TooltipTrigger;
(function (TooltipTrigger) {
    TooltipTrigger["OnMouseEnter"] = "onmouseover";
    TooltipTrigger["Manual"] = "manual";
})(TooltipTrigger || (TooltipTrigger = {}));
var ModalEvents;
(function (ModalEvents) {
    ModalEvents["open"] = "closeModal";
    ModalEvents["close"] = "openModal";
})(ModalEvents || (ModalEvents = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { Breakpoints, ColorTheme, LabelPosition, MediaBreakpoints, ModalEvents, Position, SlideDirection, TooltipTrigger };
